export default function HowTrainingGoes() {
  const steps = [
    { icon: 'ri-magic-line', title: 'Диагностика', desc: 'Анализируем текущую ситуацию в отделе: конверсию, типичные ошибки, уровень навыков диагностики' },
    { icon: 'ri-headphone-line', title: 'Изучение переговоров', desc: 'Прослушиваем записи реальных звонков и встреч, изучаем переписки с клиентами' },
    { icon: 'ri-settings-3-line', title: 'Адаптация программы', desc: 'Настраиваем содержание и упражнения под продукт компании, цикл сделки и уровень команды' },
    { icon: 'ri-presentation-line', title: 'Практический тренинг', desc: 'Интенсивная работа: 80% практики — ролевые переговоры, разбор записей, бизнес-игры' },
    { icon: 'ri-user-voice-line', title: 'Ролевые переговоры', desc: 'Отработка техник на смоделированных сценариях из реальной практики компании' },
    { icon: 'ri-task-line', title: 'Домашние задания', desc: 'Применение новых навыков в работе между модулями с записью результатов' },
    { icon: 'ri-file-search-line', title: 'Разбор звонков', desc: 'Совместный анализ новых записей: что улучшилось, над чем ещё работать' },
    { icon: 'ri-road-map-line', title: 'Сопровождение', desc: 'Посттренинговая поддержка: аудит переговоров, обратная связь, корректировка стратегии' },
  ];

  return (
    <section id="program" className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Как проходит корпоративное обучение
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Восемь этапов — от диагностики до сопровождения. Каждый шаг направлен на устойчивое внедрение, а не на разовое мероприятие.
          </p>
        </div>

        <div className="relative max-w-3xl mx-auto">
          <div className="absolute left-6 top-0 bottom-0 w-0.5 bg-teal-200 hidden md:block"></div>

          <div className="space-y-6">
            {steps.map((item, i) => (
              <div key={i} className="relative flex items-start gap-5 md:gap-8">
                <div className="relative z-10 w-12 h-12 bg-teal-600 rounded-full flex items-center justify-center flex-shrink-0 shadow-lg">
                  <i className={`${item.icon} text-white text-lg`}></i>
                </div>
                <div className="bg-white rounded-xl p-5 md:p-6 flex-1 border border-gray-100 hover:border-teal-100 transition-colors">
                  <h3 className="text-base font-bold text-gray-900 mb-2">{item.title}</h3>
                  <p className="text-sm text-gray-600 leading-relaxed">{item.desc}</p>
                </div>
                <div className="hidden md:flex items-center gap-2 absolute left-6 top-14 text-xs text-gray-400">
                  <span>Этап {i + 1}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}